import React from "react";
import { NavLink } from "react-router-dom";
import { getClosest, getSiblings, slideToggle, slideUp } from "../../../utils";
import navLinks from "../../../data/navLinks";

const MobileNavMenu = () => {
  const onClickHandler = (e) => {
    const target = e.currentTarget;
    const parentEl = target.parentElement;
    if (
      parentEl?.classList.contains("menu-toggle") ||
      target.classList.contains("menu-toggle")
    ) {
      const element = target.classList.contains("icon") ? parentEl : target;
      const parent = getClosest(element, "li");
      const childNodes = parent.childNodes;
      const parentSiblings = getSiblings(parent);
      parentSiblings.forEach((sibling) => {
        const sibChildNodes = sibling.childNodes;
        sibChildNodes.forEach((child) => {
          if (child.nodeName === "UL") {
            slideUp(child, 1000);
          }
        });
      });
      childNodes.forEach((child) => {
        if (child.nodeName === "UL") {
          slideToggle(child, 1000);
        }
      });
    }
  };

  return (
    <nav className="site-mobile-menu">
      <ul className="flex flex-col">
        <li className="border-b border-gray-300">
          <NavLink
            to={process.env.PUBLIC_URL + "/"}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">Home</span>
          </NavLink>
        </li>
        <li className="border-b border-gray-300">
          <NavLink
            to={process.env.PUBLIC_URL + "/about"}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">About Us</span>
          </NavLink>
        </li>
        <li className="menu-toggle border-b border-gray-300">
          <span
            className="block py-2 px-4 text-white cursor-pointer"
            onClick={onClickHandler}
          >
            Services
          </span>
          <ul className="sub-menu pl-4">
            {navLinks
              .find((link) => link.label === "Services")
              .children.map((child, index) => (
                <li
                  key={child.label}
                  className={
                    index ===
                    navLinks.find((link) => link.label === "Services").children
                      .length -
                      1
                      ? ""
                      : "border-b border-gray-300"
                  }
                >
                  <NavLink
                    to={process.env.PUBLIC_URL + child.href}
                    className="block py-2 px-4 text-gray-700"
                  >
                    <span className="menu-text">{child.label}</span>
                  </NavLink>
                </li>
              ))}
          </ul>
        </li>
        <li className="border-b border-gray-300">
          <NavLink
            to={process.env.PUBLIC_URL + "/blog-grid"}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">Blogs</span>
          </NavLink>
        </li>

        <li className="border-b border-gray-300">
          {/* <NavLink
            to={process.env.PUBLIC_URL + "/contact"}
            reloadDocument={true}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">Contact Us</span>
          </NavLink> */}
          <NavLink to="/contact" className="block py-2 px-4 text-gray-700">
            <span className="menu-text">Contact Us</span>
          </NavLink>
        </li>
        <li className="border-b border-gray-300">
          <NavLink
            to={process.env.PUBLIC_URL + "/meeting"}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">Meeting</span>
          </NavLink>
        </li>
        <li className="border-b border-gray-300">
          <NavLink
            to={process.env.PUBLIC_URL + "/loginPopup"}
            className="block py-2 px-4 text-gray-700"
          >
            <span className="menu-text">Login</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default MobileNavMenu;
